import type { FaireProductEntity } from "../../entity_types/product";

export const p_u7w8dc24bf: FaireProductEntity = {
  token: "p_u7w8dc24bf",
  type: "product",
  name: "Gemstone Squirrel Figurines Small  – Assorted Carved Crystal Animals",
  brandToken: "b_at4bwf6pjp",
  brandName: "Keystone Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/31ae1ba8889871c1c4fa800ff93fe3ca83fc9e09246270ac00dff8c87f153f4c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e9c4ec78a794ac8c291d58f43818017ac77b9ba3657c549e3df167f0cf6437f.jpeg",
    "https://cdn.faire.com/fastly/865c944da38f6951559da0f77dcb93533f3790fc251394e2992c1561fe8f2cb8.jpeg",
    "https://cdn.faire.com/fastly/e15aa5bf2b7eacf69186faec7da7be99680128125548ea85ef233ab664f11d8b.jpeg",
    "https://cdn.faire.com/fastly/efa9af3487c85bd9f394516d7f69a36b8469b04b48c27153a1bac0eeb7a5d8ce.jpeg",
    "https://cdn.faire.com/fastly/a9e7ab0f1718c4c5fdd0d03d44323f2e174b8bcaa8ac8d02d3c1a5404e85266b.jpeg",
    "https://cdn.faire.com/fastly/25fb24faca121557270b6ddbf6424b601d3446e9192be1ec91ca960bce3f8029.jpeg",
    "https://cdn.faire.com/fastly/464f1b3a3f32fcb6f73f8313b300ba521833c816abf323feb3d10fad4208ccdf.jpeg",
    "https://cdn.faire.com/fastly/5d2a66f50163b1b2a6bb56bbfa1856f9721ea0998129a99c2f2ab57fb69a25e5.jpeg",
    "https://cdn.faire.com/fastly/3048ffd3e64a3364e0d7daf0075a52105e992c72101b693971ad6cefe277ae36.jpeg",
    "https://cdn.faire.com/fastly/ff82dceae607fe110f7733429b4f3fbe3cf36ed4bd2e67f741d9be513855134e.jpeg",
  ],
  priceDollars: 3.19,
  description:
    "Bring playful charm and positive energy to your shop with these Small Gemstone Squirrel Figurines, carved from a variety of crystals. Each squirrel showcases unique color patterns and crystal properties, making every piece one of a kind. Ideal for crystal collectors, metaphysical boutiques, and gift retailers, these mini gemstone squirrels make delightful additions to display cases or gift assortments.\n\nSold individually with a minimum of 3 per style.\n",
  tags: [],
  msrpDollars: 6.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:47.985Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
